// These media queries are used with Styletron/BaseWeb
// Keep in sync with the media queries used in the scss globals!

export const minBreakpoints = {
  // xxs <376
  xs: 360,
  sm: 540,
  md: 834,
  lg: 960,
  xl: 1200,
  xxl: 1400
};

// Screen sizes:
// - for "xxs" try to use the default styles => "mobile first"
export const xxs = `max-width: ${minBreakpoints.xs - 1}px`;
export const xs = `min-width: ${minBreakpoints.xs}px`;
export const sm = `min-width: ${minBreakpoints.sm}px`;
export const md = `min-width: ${minBreakpoints.md}px`;
export const lg = `min-width: ${minBreakpoints.lg}px`;
export const xl = `min-width: ${minBreakpoints.xl}px`;
export const xxl = `min-width: ${minBreakpoints.xxl}px`;
